import { useState } from "react";
import { ChevronLeft, ChevronRight, BadgeCheck, ExternalLink } from "lucide-react";
import { CERTIFICATES } from "@/data/content";
import { SmartImg } from "@/components/primitives";

export default function CertsWindow() {
    const [index, setIndex] = useState(0);
    const cert = CERTIFICATES[index];

    return (
        <div data-testid="certs-window" className="flex flex-col h-full min-h-0 bg-[#17181c] text-neutral-200">
            <div className="flex items-center justify-between px-4 py-2.5 border-b border-white/10 font-mono text-[11px] text-neutral-400 shrink-0">
                <span className="truncate">{cert.id.toLowerCase()}-{cert.issuer.toLowerCase()}.webp</span>
                <span className="inline-flex items-center gap-1.5 text-vermilion font-bold text-[10px] uppercase tracking-[0.15em]">
                    <BadgeCheck size={12} /> Verified
                </span>
            </div>
            <div className="flex-1 min-h-0 flex items-center justify-center p-4 bg-[#101114]">
                <SmartImg
                    key={cert.id}
                    src={cert.image}
                    alt={cert.title}
                    className="max-h-full max-w-full object-contain rounded shadow-2xl"
                />
            </div>
            <div className="shrink-0 border-t border-white/10 px-4 py-3 flex items-center justify-between gap-3">
                <button
                    data-testid="cert-prev-button"
                    onClick={() => setIndex((i) => (i - 1 + CERTIFICATES.length) % CERTIFICATES.length)}
                    className="inline-flex items-center gap-1.5 rounded-md border border-white/15 px-3 py-1.5 text-xs hover:bg-white/10 transition-colors"
                >
                    <ChevronLeft size={13} /> Prev
                </button>
                <div className="text-center min-w-0">
                    <div className="text-xs font-semibold truncate">{cert.title}</div>
                    <div className="font-mono text-[10px] text-neutral-500">
                        image {index + 1} of {CERTIFICATES.length} — {cert.issuer}
                    </div>
                    <a
                        href={cert.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="cert-view-link"
                        className="mt-1 inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.15em] text-vermilion hover:underline underline-offset-2"
                    >
                        <ExternalLink size={10} /> View credential
                    </a>
                </div>
                <button
                    data-testid="cert-next-button"
                    onClick={() => setIndex((i) => (i + 1) % CERTIFICATES.length)}
                    className="inline-flex items-center gap-1.5 rounded-md border border-white/15 px-3 py-1.5 text-xs hover:bg-white/10 transition-colors"
                >
                    Next <ChevronRight size={13} />
                </button>
            </div>
        </div>
    );
}
